export default "__VITE_ASSET__DSEvShy4__"